import bus from 'public/utils/bus'
// import { md5Http } from 'public/utils/common'
import { getToken } from 'public/utils/token'
import { REST } from 'public/config'
import axios from 'axios'

const appId = `gj_xdbvffz-hYOdFXSRlMg==`
const time = 1 * 60 * 1000 // 1分钟
let interval = null

bus.$on('APP_LOADED', poll)

function poll() {
  if (interval) {
    window.clearInterval(interval)
  }
  interval = setInterval(request, time)
}

function request() {
  let token = getToken()
  // let now = Date.now()
  let userId = (window.__ERPUSER__ && window.__ERPUSER__.id) || ''
  let data = {appId, userId, assetsSign: window.btoa(token)}
  axios({
    method: 'post',
    url: `${REST}?urmcollect.userStatus.beat`,
    data,
    headers: {
      format: 'JSON',
      method: 'urmcollect.userStatus.beat',
      appkey: 55324
      // timestamp: now,
      // sign: md5Http(token, now, data)
    }
  }).then(e => {
    let code = e && e.data && e.data.code
    if (code && [100201, 6001].indexOf(code) >= 0) {
      window.clearInterval(interval)
    }
  }).catch(e => {
    console.error(e)
  })
}



// WEBPACK FOOTER //
// ./src/layout/layout/setup/online-status.js